import axios from 'axios';

const METABUILD_BASE_URL = 'http://metabuild.epu.ntua.gr:8001';
const METABUILD_AUTH = {
    username: 'Mm99ag',
    password: 'Om1ekt66pl78',
};

// Helper to get date range for last 7 days
const getDateRange = () => {
    const end = new Date();
    const start = new Date(end);
    start.setDate(start.getDate() - 7);
    return {
        startTimestamp: start.toISOString().slice(0, 19).replace('T', 'T'),
        endTimestamp: end.toISOString().slice(0, 19).replace('T', 'T'),
        startDate: start.toISOString().slice(0, 10),
        endDate: end.toISOString().slice(0, 10),
    };
};

// Netatmo: temperature, co2, humidity (UTC)
export const getNetatmoData = (netatmoId) => {
    const { startTimestamp, endTimestamp } = getDateRange();
    return axios.get(`${METABUILD_BASE_URL}/netatmomodel/${netatmoId}/data/`, {
        auth: METABUILD_AUTH,
        params: { start_timestamp: startTimestamp, end_timestamp: endTimestamp },
    });
};

// Shelly: consumption (local time Greece)
export const getShellyData = (shellyId) => {
    const { startDate, endDate } = getDateRange();
    return axios.get(`${METABUILD_BASE_URL}/shelly/data/shellyid/${shellyId}`, {
        auth: METABUILD_AUTH,
        params: { start_date: startDate, end_date: endDate },
    });
};

// Heatpump: energyconsumption or sensorydata
export const getHeatpumpEnergyData = (heatpumpId) => {
    const { startTimestamp, endTimestamp } = getDateRange();
    return axios.get(`${METABUILD_BASE_URL}/heatpumpmodel/${heatpumpId}/data/energyconsumption`, {
        auth: METABUILD_AUTH,
        params: { start_timestamp: startTimestamp, end_timestamp: endTimestamp },
    });
};

export const getHeatpumpSensoryData = (heatpumpId) => {
    const { startTimestamp, endTimestamp } = getDateRange();
    return axios.get(`${METABUILD_BASE_URL}/heatpumpmodel/${heatpumpId}/data/sensorydata`, {
        auth: METABUILD_AUTH,
        params: { start_timestamp: startTimestamp, end_timestamp: endTimestamp },
    });
};
